import { useRef } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { UploadCloud } from "lucide-react";

export const LogoDrop = ({ label, help, value, onChange, testid }) => {
  const fileRef = useRef(null);
  const onFile = (file) => {
    if (!file) return;
    if (!file.type.startsWith("image/")) { toast.error("Please choose an image file"); return; }
    if (file.size > 700 * 1024) { toast.error("Image too large — keep under 700KB"); return; }
    const reader = new FileReader();
    reader.onload = () => onChange(reader.result);
    reader.readAsDataURL(file);
  };
  return (
    <div>
      <Label className="text-xs font-semibold text-slate-600">{label}</Label>
      {help && <p className="mt-0.5 text-[10px] text-slate-400">{help}</p>}
      <div
        onDragOver={(e) => e.preventDefault()}
        onDrop={(e) => { e.preventDefault(); onFile(e.dataTransfer.files?.[0]); }}
        onClick={() => fileRef.current?.click()}
        data-testid={`${testid}-dropzone`}
        className="mt-1.5 flex cursor-pointer flex-col items-center justify-center gap-2 rounded-xl border-2 border-dashed border-teal-300 bg-teal-50/40 px-4 py-7 text-center transition-colors hover:border-teal-500 hover:bg-teal-50"
      >
        {value ? (
          <img src={value} alt={`${label} preview`} data-testid={`${testid}-preview`} className="h-16 max-w-full rounded-lg bg-white object-contain p-1 ring-1 ring-slate-200" />
        ) : (
          <UploadCloud className="h-8 w-8 text-teal-500" />
        )}
        <span className="text-xs font-medium text-slate-600">{value ? "Click or drop a new image to replace" : "Drag an image here, or click to upload"}</span>
        <input ref={fileRef} type="file" accept="image/*" className="hidden" onChange={(e) => onFile(e.target.files?.[0])} data-testid={`${testid}-file`} />
      </div>
      <Input value={value?.startsWith("data:") ? "" : value} onChange={(e) => onChange(e.target.value)} data-testid={`${testid}-url`} className="mt-2" placeholder="…or paste a logo image URL" />
      {value && <button onClick={() => onChange("")} data-testid={`${testid}-remove`} className="mt-1 text-[11px] text-red-500 hover:underline">Remove logo</button>}
    </div>
  );
};
